import { render, staticRenderFns } from "./completePro.vue?vue&type=template&id=708dce1a&scoped=true&"
import script from "./completePro.vue?vue&type=script&lang=js&"
export * from "./completePro.vue?vue&type=script&lang=js&"
import style0 from "./completePro.vue?vue&type=style&index=0&id=708dce1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708dce1a",
  null
  
)

export default component.exports